import React from "react"
import styled from "styled-components"
import { getCssSizeValue } from "@/utils/utils"

const StyledGridContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	margin-left: ${getCssSizeValue(20, "mobile")};
	margin-right: ${getCssSizeValue(20, "mobile")};
	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		margin-left: ${getCssSizeValue(40, "tablet")};
		margin-right: ${getCssSizeValue(40, "tablet")};
		grid-template-columns: repeat(5, 1fr);
	}
	@media (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
		margin-left: ${getCssSizeValue(70, "desktop")};
		margin-right: ${getCssSizeValue(70, "desktop")};
		grid-gap: 0;
		//grid-gap: var(--grid-gap);
		grid-template-columns: repeat(5, 1fr);
	}

	&.fixed-tester {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 100%;
		padding: 0 ${getCssSizeValue(70, "desktop")};
		margin: 0;
		background-color: ${({ theme }) => theme.colors.slateGray};
	}

	.col-1 {
		grid-column: span 1;
	}

	.col-2 {
		grid-column: span 2;
	}

	.col-3 {
		grid-column: span 3;
	}

	.col-4 {
		grid-column: span 4;
	}

	.col-5 {
		grid-column: span 5;
	}

	&.no-margin {
		margin-left: 0;
		margin-right: 0;
	}

	&.no-margin-l {
		margin-left: 0;
	}

	&.no-margin-r {
		margin-right: 0;
	}

	&.padding {
		padding-left: var(--grid-margin-l);
		padding-right: var(--grid-margin-r);
	}
`
const GridContainerFiveColumns = ({ className = "", children, style }) => {
	return (
		<StyledGridContainer className={className} style={style}>
			{children}
		</StyledGridContainer>
	)
}

export default GridContainerFiveColumns
